import React from "react";
import styled from "styled-components";
import CustomSwitch from "../../../CustomSwitch";
import Dropdown from "../../../Dropdown";
import TextView from "../../../TextView";
import MarginBox from "../../Shared/MarginBox";

const Container = styled.div``;

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const columnsArray = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
];

export default function Layout({
  margin,
  isApplyMarginOnAllSides,
  allSideMargin,
  showThumbnail,
  handleChange,
  handleAdjustment,
  columns,
}) {
  return (
    <Container>
      {/* <Row>
        <TextView variant="subtitle">Display Thumbnail</TextView>
        <CustomSwitch
          checked={showThumbnail}
          onChange={() => handleChange("showThumbnail")}
        />
      </Row>
      <Dropdown
        label={"Number of Columns"}
        labelVariant={"subtitle"}
        variant="outlined"
        options={columnsArray}
        value={columns}
        defaultValue={columns}
        onChange={(e) => handleChange("columns", e.target.value)}
        style={{ marginBottom: 20 }}
      /> */}
      <MarginBox
        margin={margin}
        increaseMargin={(side) => handleAdjustment(side, "increase")}
        decreaseMargin={(side) => handleAdjustment(side, "decrease")}
        isApplyMarginOnAllSides={isApplyMarginOnAllSides}
        allSideMargin={allSideMargin}
        handleMarginCheckBox={() => handleChange("marginCheckbox")}
        handleSliderMarginChange={(value) =>
          handleChange("allSideMargin", value)
        }
        handleMarginChange={(side, value) =>
          handleChange("margin", value, side)
        }
        symbol={"px"}
      />
    </Container>
  );
}
